'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-512/node_modules/@eliadmin/core/src/components/order-status/order-status-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-512/node_modules/@eliadmin/core/src/components/order-status/order-status-form.tsx").OrderStatusForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/orderStatusForm").then(m => ({ default: m.OrderStatusForm })));
export function OrderStatusForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

